import React, {useEffect, useState} from 'react';
import "./AllEventsYears.scss";
import AllEventsApi from "../../../../api/AllEventsApi";
import YearItem from "../../EventsByYear/YearItem/YearItem";
import * as actionCreators from "../../../../store/actions/actions";
import {connect} from "react-redux";
import UrlManager from "../../../../tools/UrlManager";
import Loading from "../../../../components/Loading/Loading";
import {Grid2} from "@mui/material";

function AllEventsYears(props) {
    const [years, setYears] = useState([]);
    const [labels, setLabels] = useState(null);

    const setCurrentNavigationYear = (navigationYear) => {
        props.onUpdateCurrentNavigationYear(navigationYear);
    }


    useEffect(() => {
        if ( props.userId ) {
            AllEventsApi.getByYears(props.userId).then(response => {
                setYears(response.rows);
            } ).catch(error => {
                //TODO catch
            });
            AllEventsApi.getLabels(props.userId, 'y').then(response => {
                const labelsObject = Object.fromEntries(
                    response.map(item => [item.userdate, { userimage: item.userimage, transform: item.transform ?? null }])
                );
                setLabels(labelsObject);
            } ).catch(error => {
                //TODO catch
            });
        }
    }, [props.userId]);


    return props.userId ? <div className="AllEventsYears">
        <Grid2 container spacing={2}>{years.length > 0 ? years.map(yearInfo => {
            return (
                <Grid2 sx={{border: parseInt(yearInfo.eventsYear) === parseInt(props.currentNavigationYear) ? '2px solid #1976d2' : ''}} key={yearInfo.eventsYear} size={{ xs: 12, sm: 4, lg: 2 }} onClick = {() => {
                    setCurrentNavigationYear(yearInfo.eventsYear);
                    UrlManager.setUrl(props.userId, yearInfo.eventsYear);
                }}>
                    <YearItem item={yearInfo} label={labels ? (labels[yearInfo.eventsYear] ?? false) : null} />
                </Grid2>
            )
    }) : <Loading />}</Grid2></div> : '';
}

const mapStateToProps = state => {
    return {
        currentNavigationYear: state.eventsData.currentNavigationYear
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateCurrentNavigationYear: (currentNavigationYear) => dispatch(actionCreators.updateNavigationYear(currentNavigationYear))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AllEventsYears);
